import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'

export const PageContainer = styled(Box)(({ theme }) => ({
    paddingLeft: '10rem',
    paddingRight: '5rem',
    [theme.breakpoints.down('sm')]: {
        padding: '0%'
    },
}))